import client from './client';

/**
 * Session Questions API
 * Backend: /api/sessions/{sessionId}/questions  (Phase 1)
 */

export const listSessionQuestions = (sessionId) =>
  client.get(`/api/sessions/${sessionId}/questions`);

export const attachSessionQuestion = (sessionId, payload) =>
  client.post(`/api/sessions/${sessionId}/questions`, payload);

export const attachSessionQuestionSet = (sessionId, setId) =>
  client.post(`/api/sessions/${sessionId}/questions/from-set/${setId}`);

export const updateSessionQuestion = (sessionId, questionId, payload) =>
  client.patch(`/api/sessions/${sessionId}/questions/${questionId}`, payload);

export const detachSessionQuestion = (sessionId, questionId) =>
  client.delete(`/api/sessions/${sessionId}/questions/${questionId}`);
